module.exports = __webpack_public_path__ + "img/join-us-10.bb20051e.png";